// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3qk3A","icon":"SortAdornment_icon__1n8_m","up":"SortAdornment_up__3sH2-","down":"SortAdornment_down__1p83I","active":"SortAdornment_active__gNhXh"};